// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PFGO","question":"styles_question__rFPU2","description":"styles_description__2A2xl"};